<template>
    <div class="product-page">
        <div v-if="productType=='A'"  class="product-page-content">
            <div class="product-mainimg">
                <img :src="productInfo.mobileProduct_img1" alt="" style="width:100%;">
            </div>
            <div class="product-introduce">
                <div class="product-title">
                    产品简介
                </div>
                <div class="product-text">
                     {{productInfo.productIntroduceDesc}}
                </div>
            </div>
            <div class="product-descripte">
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img2">
                    <img :src="productInfo.mobileProduct_img2" alt="" style="width:100%;">
                </div>
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img3">
                    <img :src="productInfo.mobileProduct_img3" alt="" style="width:100%;">
                </div>
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img4">
                    <img :src="productInfo.mobileProduct_img4" alt="" style="width:100%;">
                </div>
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img5">
                    <img :src="productInfo.mobileProduct_img5" alt="" style="width:100%;">
                </div>
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img6">
                    <img :src="productInfo.mobileProduct_img6" alt="" style="width:100%;">
                </div>
            </div>
            <div class="product-parameter">
                <div class="product-parameter-top clearfix">
                    <div class="product-parameter-top-left">产品参数</div>
                    <div class="product-parameter-top-right" @click="gotoDetailParameter">查看全部参数<span class="el-icon-arrow-right"></span></div>
                </div>
                <div class="product-parameter-main">
                    <div class="product-parameter-main-row" v-for="(item,index) in productInfoParameter" :key="index">
                       <div class="product-parameter-main-row-title" v-if="item.name=='PrintingTechnology'">
                            <span>打印技术</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printingresolution'">
                            <span>打印分辨率</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PrintingWay'">
                            <span>打印方式</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printingfunction'">
                            <span>打印功能</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printingspeed'">
                            <span>打印速度</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printingthickness'">
                            <span>卡片厚度</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Securitycharacteristics'">
                            <span>安全特性</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Enteringcard'">
                            <span>自动进卡功能</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='sys'">
                            <span>支持系统</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ElectromechanicalControl'">
                            <span>机电控制</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='processor'">
                            <span>处理器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='DigitalTube'">
                            <span>数码管</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='storage'">
                            <span>存储</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CPU'">
                            <span>中央处理器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ExternalStorage'">
                            <span>片外存储</span>
                        </div>

                        <div class="product-parameter-main-row-title" v-if="item.name=='Display'">
                            <span>显示屏</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='MainDisplay'">
                            <span>主显示屏</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='SecondaryDisplay'">
                            <span>次显示屏</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='productLevel'">
                            <span>防护等级</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='touchScreen'">
                            <span>触摸屏</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='led'">
                            <span>指示灯</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='EEP'">
                            <span>EEP</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PSAM'">
                            <span>PSAM</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Sweepled'">
                            <span>扫码指示灯</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printer'">
                            <span>打印机</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='tickertape'">
                            <span>打印凭条</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='passKey'">
                            <span>密码键盘</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='keyboard'">
                            <span>键盘</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='functionKey'">
                            <span>功能按键</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FillinLight'">
                            <span>补光灯</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='LightPerception'">
                            <span>光感</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ExternalInterface'">
                            <span>外置接口</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Buzzer'">
                            <span>蜂鸣器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Voice'">
                            <span>语音</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PreventLook'">
                            <span>防窥罩</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='key'">
                            <span>按键</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='MagneticChuck'">
                            <span>磁卡槽</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='encryption'">
                            <span>加密</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Voltage'">
                            <span>电压</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FalaCapacitance'">
                            <span>法拉电容</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='speaker'">
                            <span>扬声器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='communicationInterface'">
                            <span>通讯接口</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CashRegister'">
                            <span>现金模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ScanningHead'">
                            <span>扫描头</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ReadMagneticCard'">
                            <span>读磁条卡</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='readIcCard'">
                            <span>读IC卡</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ISContactCard'">
                            <span>接触式卡</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='NOTContactCard'">
                            <span>非接触卡</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='safeChip'">
                            <span>安全芯片</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='communicationWire'">
                            <span>通讯线</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='wireless'">
                            <span>无线通讯</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='SAM'">
                            <span>SAM卡座</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='SAMCCC'">
                            <span>SAM卡槽</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Inductiondistance'">
                            <span>感应距离</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='TF'">
                            <span>TF卡座</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='SIM'">
                            <span>SIM卡座</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ReadSecondIdCard'">
                            <span>读二代证</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Ethernet'">
                            <span>以太网</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='WIFI'">
                            <span>WIFI模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='AllNetworks'">
                            <span>全网通模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Bluetooth'">
                            <span>蓝牙</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='wiring'">
                            <span>配线</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='RTC'">
                            <span>实时RTC</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='brushCodeHeader'">
                            <span>扫码头</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='structural'">
                            <span>结构方式</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='cooperration'">
                            <span>定位</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='speed'">
                            <span>交易速度</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='cassette'">
                            <span>卡座</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Biometrics'">
                            <span>生物识别</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='barcode'">
                            <span>条码阅读器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Camera'">
                            <span>摄像头</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FaceDatabase'">
                            <span>人脸库容量</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Verification'">
                            <span>核验方式</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PersonnelManagement'">
                            <span>人员管理</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='StrangeManagement'">
                            <span>陌生人管理</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='RecordManagement'">
                            <span>记录管理</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='RemoteUpgrade'">
                            <span>远程升级</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='onlineUpgrade'">
                            <span>在线升级</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='VoiceAnnouncements'">
                            <span>语音播报</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FingerPrint'">
                            <span>指纹识别</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FaceRecognition'">
                            <span>人脸识别</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ScanningModule'">
                            <span>扫码模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='GPS'">
                            <span>GPS</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='MIC'">
                            <span>MIC</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CommunicationMode'">
                            <span>通讯方式</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PhysicalInterface'">
                            <span>物理接口</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='HeatDissipationAndStaticElectricity'">
                            <span>散热与静电</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='StructuralDismantling'">
                            <span>结构防拆</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Clock'">
                            <span>实时时钟</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Battery'">
                            <span>电池</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='buttonBattery'">
                            <span>纽扣电池</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='power'">
                            <span>电源</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PowerSwitch'">
                            <span>电源开关</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Indicativestatus'">
                            <span>指示状态</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Carrierspeed'">
                            <span>走卡速度</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Specialtreatment'">
                            <span>特殊处理</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CardCapacity'">
                            <span>卡容量</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CardType'">
                            <span>卡片类型</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='DissipateHeat'">
                            <span>散热</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='workEnvironment'">
                            <span>工作环境</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='saveEnvironment'">
                            <span>存储环境</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='weight'">
                            <span>重量</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='drive'">
                            <span>驱动</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='menu'">
                            <span>配件清单</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Inputmodule'">
                            <span>输入模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='outputmodule'">
                            <span>输出模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='otherCharacteristic'">
                            <span>其他特性</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Secondarydevelopment'">
                            <span>二次开发</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='standard'">
                            <span>符合标准</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='InstitutionalCertification'">
                            <span>机构认证</span>
                        </div>
                        <div class="product-parameter-main-row-text">{{item.data}}</div>
                    </div>

                </div>
            </div>
        </div>
        <div v-if="productType=='B'" class="product-page-content">
            <div class="product-mainimg">
                <img :src="productInfo.mobileProduct_img1" alt="" style="width:100%;">
            </div>
            <div class="product-introduce">
                <div class="product-title">
                    产品简介
                </div>
                <div class="product-text">
                     {{productInfo.productIntroduceDesc}}
                </div>
            </div>
            <div class="product-descripte">
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img2">
                    <img :src="productInfo.mobileProduct_img2" alt="" style="width:100%;">
                </div>
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img3">
                    <img :src="productInfo.mobileProduct_img3" alt="" style="width:100%;">
                </div>
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img4">
                    <img :src="productInfo.mobileProduct_img4" alt="" style="width:100%;">
                </div>
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img5">
                    <img :src="productInfo.mobileProduct_img5" alt="" style="width:100%;">
                </div>
                <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img6">
                    <img :src="productInfo.mobileProduct_img6" alt="" style="width:100%;">
                </div>
                 <div class="product-descripte-imgpart" v-if="productInfo&&productInfo.mobileProduct_img7">
                    <img :src="productInfo.mobileProduct_img7" alt="" style="width:100%;">
                </div>
            </div>
            <div class="product-parameter">
                <div class="product-parameter-top clearfix">
                    <div class="product-parameter-top-left">产品参数</div>
                    <div class="product-parameter-top-right" @click="gotoDetailParameter">查看全部参数<span class="el-icon-arrow-right"></span></div>
                </div>
                <div class="product-parameter-main">
                    <div class="product-parameter-main-row" v-for="(item,index) in productInfoParameter" :key="index">
                        <div class="product-parameter-main-row-title" v-if="item.name=='PrintingTechnology'">
                            <span>打印技术</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printingresolution'">
                            <span>打印分辨率</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PrintingWay'">
                            <span>打印方式</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printingfunction'">
                            <span>打印功能</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printingspeed'">
                            <span>打印速度</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printingthickness'">
                            <span>卡片厚度</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Securitycharacteristics'">
                            <span>安全特性</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Enteringcard'">
                            <span>自动进卡功能</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='sys'">
                            <span>支持系统</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ElectromechanicalControl'">
                            <span>机电控制</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='processor'">
                            <span>处理器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='DigitalTube'">
                            <span>数码管</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='storage'">
                            <span>存储</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CPU'">
                            <span>中央处理器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ExternalStorage'">
                            <span>片外存储</span>
                        </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='Display'">
                        <span>显示屏</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='sysMemory'">
                        <span>系统内存</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='cpuType'">
                        <span>CPU类型</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='liquidCrystal'">
                        <span>液晶屏</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='motherboardChipsetType'">
                        <span>主板芯片组类型</span>
                      </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='MainDisplay'">
                            <span>主显示屏</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='SecondaryDisplay'">
                            <span>次显示屏</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='productLevel'">
                            <span>防护等级</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='touchScreen'">
                            <span>触摸屏</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='led'">
                            <span>指示灯</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='EEP'">
                            <span>EEP</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PSAM'">
                            <span>PSAM</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Sweepled'">
                            <span>扫码指示灯</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Printer'">
                            <span>打印机</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='tickertape'">
                            <span>打印凭条</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='passKey'">
                            <span>密码键盘</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='keyboard'">
                            <span>键盘</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='functionKey'">
                            <span>功能按键</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FillinLight'">
                            <span>补光灯</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='LightPerception'">
                            <span>光感</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ExternalInterface'">
                            <span>外置接口</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Buzzer'">
                            <span>蜂鸣器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Voice'">
                            <span>语音</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PreventLook'">
                            <span>防窥罩</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='key'">
                            <span>按键</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='MagneticChuck'">
                            <span>磁卡槽</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='encryption'">
                            <span>加密</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Voltage'">
                            <span>电压</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FalaCapacitance'">
                            <span>法拉电容</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='speaker'">
                            <span>扬声器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='communicationInterface'">
                            <span>通讯接口</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CashRegister'">
                            <span>现金模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ScanningHead'">
                            <span>扫描头</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ReadMagneticCard'">
                            <span>读磁条卡</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='readIcCard'">
                            <span>读IC卡</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ISContactCard'">
                            <span>接触式卡</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='NOTContactCard'">
                            <span>非接触卡</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='safeChip'">
                            <span>安全芯片</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='communicationWire'">
                            <span>通讯线</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='wireless'">
                            <span>无线通讯</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='SAM'">
                            <span>SAM卡座</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='SAMCCC'">
                            <span>SAM卡槽</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Inductiondistance'">
                            <span>感应距离</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='TF'">
                            <span>TF卡座</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='SIM'">
                            <span>SIM卡座</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ReadSecondIdCard'">
                            <span>读二代证</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Ethernet'">
                            <span>以太网</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='WIFI'">
                            <span>WIFI模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='AllNetworks'">
                            <span>全网通模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Bluetooth'">
                            <span>蓝牙</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='wiring'">
                            <span>配线</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='RTC'">
                            <span>实时RTC</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='brushCodeHeader'">
                            <span>扫码头</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='structural'">
                            <span>结构方式</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='cooperration'">
                            <span>定位</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='speed'">
                            <span>交易速度</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='cassette'">
                            <span>卡座</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Biometrics'">
                            <span>生物识别</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='barcode'">
                            <span>条码阅读器</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Camera'">
                            <span>摄像头</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FaceDatabase'">
                            <span>人脸库容量</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Verification'">
                            <span>核验方式</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PersonnelManagement'">
                            <span>人员管理</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='StrangeManagement'">
                            <span>陌生人管理</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='RecordManagement'">
                            <span>记录管理</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='RemoteUpgrade'">
                            <span>远程升级</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='onlineUpgrade'">
                            <span>在线升级</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='VoiceAnnouncements'">
                            <span>语音播报</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FingerPrint'">
                            <span>指纹识别</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='FaceRecognition'">
                            <span>人脸识别</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ScanningModule'">
                            <span>扫码模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='GPS'">
                            <span>GPS</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='MIC'">
                            <span>MIC</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CommunicationMode'">
                            <span>通讯方式</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PhysicalInterface'">
                            <span>物理接口</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='HeatDissipationAndStaticElectricity'">
                            <span>散热与静电</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='StructuralDismantling'">
                            <span>结构防拆</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Clock'">
                            <span>实时时钟</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Battery'">
                            <span>电池</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='buttonBattery'">
                            <span>纽扣电池</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='power'">
                            <span>电源</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='PowerSwitch'">
                            <span>电源开关</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Indicativestatus'">
                            <span>指示状态</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Carrierspeed'">
                            <span>走卡速度</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Specialtreatment'">
                            <span>特殊处理</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CardCapacity'">
                            <span>卡容量</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='CardType'">
                            <span>卡片类型</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='DissipateHeat'">
                            <span>散热</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='workEnvironment'">
                            <span>工作环境</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='saveEnvironment'">
                            <span>存储环境</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='weight'">
                            <span>重量</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='drive'">
                            <span>驱动</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='menu'">
                            <span>配件清单</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Inputmodule'">
                            <span>输入模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='outputmodule'">
                            <span>输出模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='Secondarydevelopment'">
                            <span>二次开发</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='standard'">
                            <span>符合标准</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='InstitutionalCertification'">
                            <span>机构认证</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='MainControlModule'">
                          <span>主控模块</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='LCDTouchScreen'">
                          <span>液晶触摸显示屏</span>
                        </div>
                        <div class="product-parameter-main-row-title" v-if="item.name=='ElectricCardReader'">
                          <span>电动读卡器</span>
                        </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='sound'">
                        <span>音响</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='PSAMCardReadAndWriteModule'">
                        <span>PSAM卡读写模块</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='CardIssuingBox'">
                        <span>发卡箱</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='BanknoteDispenser'">
                        <span>纸币器</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='ExternalUSB'">
                        <span>外置USB接口</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='HumanProximitySensor'">
                        <span>人体接近感应器</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='ManMachinePrompt'">
                        <span>人机提示</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='PowerModule'">
                        <span>电源模组</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='RollerDesign'">
                        <span>滚轮设计</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='ProcessorHardwareConfiguration'">
                        <span>处理器硬件配置</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='Accuracy'">
                        <span>准确率</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='FaceRecognitionTime'">
                        <span>人脸识别时间</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='LivingRecognition'">
                        <span>活体识别</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='FaceDatabaseSynchronization'">
                        <span>人脸库同步</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='RemoteManagement'">
                        <span>远程管理</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='InfraredTemperatureMeasurement'">
                        <span>红外测温</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='ScreenSize'">
                        <span>屏幕尺寸</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='ScreenBrightness'">
                        <span>屏幕亮度</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='ScreenResolution'">
                        <span>屏幕分辨率</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='BodyMaterial'">
                        <span>机身材质</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='CommunicationInterface'">
                        <span>通信接口</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='OperatingSystem'">
                        <span>操作系统</span>
                      </div>
                      <div class="product-parameter-main-row-title" v-if="item.name=='otherCharacteristic'">
                        <span>其他特性</span>
                      </div>
                        <div class="product-parameter-main-row-text">{{item.data}}</div>
                    </div>
                </div>
            </div>
        </div>
        <home-foot></home-foot>
    </div>
</template>


<script>
import HomeFoot from "@/components/HomeFoot";
// import { productList } from "@/views/productList.js";
// import ProductParameter from "@/components/ProductParameter";
export default {
    name: "product",
    components:{
        // ProductParameter,
        parameter: "", //参数
        HomeFoot,
    },
    data() {
        return {
            productType:"A",
            productName:'',
            productInfoParameter:[],   //产品参数
            productInfo:"",     //产品信息
        };
    },
    methods:{
        gotoDetailParameter(){
            this.$router.push(`/productParameterDetail/${this.productType}/${this.productName}`);
        }
    },
    mounted(){
        let productNUM = this.$route.params.value;
        this.productType = this.$route.params.type;
        this.productName = this.$route.params.value;
        // productList && productList.forEach(element => {
        //     element.children.forEach(item => {
        //         if (item.value == productNUM) {
        //             this.productInfo = item.info;
        //             var array = []
        //             for(var key in item.info.parameter){
        //                 var str={};
        //                 str.name = key;
        //                 str.data = item.info.parameter[key];
        //                 array.push(str);
        //             }
        //             // this.allproductInfoParameter = array;
        //             this.productInfoParameter = array.splice(0,5)
        //         }
        //     });
        // });
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.product-page{
    margin-top: 50px;
}


/*  小屏适应性配置  */
@media only screen and (max-width:991px) {
    .product-page{
        height:100%;
    }
    .product-page-content{
    }
    .product-mainimg{
        width:100%;
    }
    .product-introduce{
        margin: 40px 0;
    }
   .product-introduce,.product-parameter{
       padding:0 9%;
    }
    .product-title{
        font-size: 18px;
        font-weight: 600;
        color: #202020;
        margin-bottom: 10px;
    }
    .product-text{
        font-size: 14px;
        line-height: 25px;
        color: #2C2C2C;
    }
    .product-descripte{
        width:100%;
    }
    .product-descripte-imgpart{
        width: 100%;
    }
    product-descripte-imgpart img{
        width:100%;
    }
    .product-parameter{
        margin-top: 25px;
    }
    .product-parameter-top{
        width: 100%;
        height: 50px;
        line-height: 50px;
        border-bottom: 0.5px solid #E2E2E2;
    }
    .product-parameter-top-left{
        float: left;
        font-size: 18px;
        font-weight: 600;
        color: #2C2C2C;
    }
    .product-parameter-top-right{
        float: right;
        font-size: 14px;
        font-weight: normal;
        color:#00ACF5;
    }
    .product-parameter-main{
        width: 100%;
        padding: 20px 0;
    }
    .product-parameter-main-row{
        width:100%;
        margin-bottom: 20px
    }
    .product-parameter-main-row-title{
        font-size: 14px;
        font-weight: 600;
        color: #2C2C2C;
        margin-bottom: 5px;
    }
    .product-parameter-main-row-text{
        font-size: 14px;
      /*color: #656565;*/
        color: #030303;
        font-weight: 300;
    }

}
</style>



// WEBPACK FOOTER //
// src/views/product.vue